import { Injectable } from '@angular/core';
import {Subject} from "rxjs";
import {Router} from "@angular/router";

declare var bootstrap: any;


@Injectable({
  providedIn: 'root'
})
export class ModalService {

  private openModalSubject = new Subject<string | null>();
  openModal$ = this.openModalSubject.asObservable();

  private modalInstances = new Map<string, any>();

  constructor(
    private router: Router
  ) { }

  open(modalId: string) {
    //to prevent error: bootstrap is not loaded yet when modal is clicked
    try {
      if (typeof bootstrap === 'undefined' || !bootstrap.Modal) {
        throw new Error('Bootstrap library is not loaded.');
      }

      const modalElement = document.getElementById(modalId);
      if (!modalElement) {
        throw new Error(`Modal element with ID ${modalId} not found.`);
      }

      // Deactivate Bootstrap modals preventing text input fields focus
      bootstrap.Modal.prototype._initializeFocusTrap = function () {
        return { activate: () => {}, deactivate: () => {} };
      };

      const modalInstance = new bootstrap.Modal(modalElement, {
        backdrop: "static",
        keyboard: false
      });
      modalInstance.show();
      this.modalInstances.set(modalId, modalInstance);
      this.openModalSubject.next(modalId);

      modalElement.addEventListener('hidden.bs.modal', () => {
        this.openModalSubject.next(null);
        this.modalInstances.delete(modalId);
        //focus is reset to body - but the "blocked arie-hidden" error happens before the reset - so have to fix it in close
        document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
      }, { once: true });


    } catch (error) {
      console.error(`Error in opening ${modalId}:`, error);
      this.router.navigate(['/legacy'])
    }
  }

  close(modalId: string) {

    const instance = this.modalInstances.get(modalId);

    if (instance) {
      instance.hide();
    } else {
      console.warn(`Modal ${modalId} was not opened through ModalService`);
    }

    //to prevent "blocked aria-hidden" error on closing modal (focus stayed on close button when the modal was closed)
    if(document.activeElement){ //this is the close button that retains focus - so we remove it
      (document.activeElement as HTMLElement).blur()
    }



  }
}
